import React from 'react';
import { navigation } from '../config/navigation';
import classNames from 'classnames';

export const Footer = ({dark}) => {

    const theme = classNames('py-10 font-semibold',
        { 'bg-gray-800 text-gray-300 border-t border-gray-600' : dark, 'bg-white text-gray-900' : !dark }
    )

    return (
        <React.Fragment>
            <div className={theme}>
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <nav aria-label="Footer" className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12">
                    {navigation.map((item) => (
                        <div key={item.name} className="pb-6">
                        <a href={item.href} className="text-sm leading-6 ">
                            {item.name}
                        </a>
                        </div>
                    ))}
                    </nav>
                    <p className="mt-10 text-center text-xs leading-5">
                    &copy; 2025 Overland Park IT All rights reserved.
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
}